import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Dashboard from '../views/Dashboard.vue'
import { menuAPI } from '../services/api'

Vue.use(Router)

// 全局路由状态，用于跟踪当前的路由配置
let currentDynamicRoutes = []
let dynamicRoutesLoaded = false

// 存储已注册的路由路径，用于快速检查路由是否存在
const registeredRoutes = new Set()

// 基础路由配置
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {      
      path: '/',      
      component: Layout,      
      redirect: '/dashboard',      
      meta: { requiresAuth: true },      
      children: [        
        {          
          path: 'dashboard',          
          name: 'Dashboard',          
          component: Dashboard,          
          meta: { title: '仪表盘', icon: 'el-icon-s-home', showInTab: true }        
        },
        {          
          path: 'banner-management',          
          name: 'BannerManagement',          
          component: () => import('@/views/BannerManagement.vue'),          
          meta: { title: 'Banner管理', icon: 'el-icon-picture-outline', showInTab: true }        
        },
        {
          path: 'knowledge-categories-management',
          name: 'KnowledgeCategoriesManagement',
          component: () => import('@/views/KnowledgeCategoriesManagement.vue'),
          meta: { title: '知识库分类管理', icon: 'el-icon-folder', showInTab: true }
        },
        {
          path: 'science-category-management',
          name: 'ScienceCategoryManagement',
          component: () => import('@/views/ScienceCategoryManagement.vue'),
          meta: { title: '科普分类管理', icon: 'el-icon-folder', showInTab: true }
        },
        {
          path: 'science-article-management',
          name: 'ScienceArticleManagement',
          component: () => import('@/views/ScienceArticleManagement.vue'),
          meta: { title: '科普文章管理', icon: 'el-icon-document', showInTab: true }
        },
        {
          path: 'science-video-management',
          name: 'ScienceVideoManagement',
          component: () => import('@/views/ScienceVideoManagement.vue'),
          meta: { title: '科普视频管理', icon: 'el-icon-video-camera', showInTab: true }
        },
        {
          path: 'brain-training-games-management',
          name: 'BrainTrainingGamesManagement',          
          component: () => import('@/views/BrainTrainingGamesManagement.vue'),          
          meta: { title: '脑力训练游戏管理', icon: 'el-icon-game', showInTab: true }        
        },
        {          
          path: 'member-points-management',          
          name: 'MemberPointsManagement',          
          component: () => import('@/views/MemberPointsManagement.vue'),          
          meta: { title: '会员积分记录', icon: 'el-icon-star', showInTab: true }        
        },
        {          
          path: 'points-rules-configuration',          
          name: 'PointsRulesConfiguration',          
          component: () => import('@/views/PointsRulesConfiguration.vue'),          
          meta: { title: '积分规则配置', icon: 'el-icon-setting', showInTab: true }        
        },
        {          
          path: 'service-page-management',          
          name: 'ServicePageManagement',          
          component: () => import('@/views/ServicePageManagement.vue'),          
          meta: { title: '服务页面管理', icon: 'el-icon-service', showInTab: true }        
        },
        {
          path: 'product-management',
          name: 'ProductManagement',
          component: () => import('@/views/ProductManagement.vue'),
          meta: { title: '产品管理', icon: 'el-icon-goods', showInTab: true }
        },
        {
          path: 'report-recognition',
          name: 'ReportRecognition',
          component: () => import('@/views/ReportRecognition.vue'),
          meta: { title: '报告识别', icon: 'el-icon-scanning', showInTab: true }
        },
        {          
          path: 'emergency-contact-management',          
          name: 'EmergencyContactManagement',          
          component: () => import('@/views/EmergencyContactManagement.vue'),          
          meta: { title: '紧急联系人管理', icon: 'el-icon-user', showInTab: true }        },
        {           
          path: 'ad-screening-submissions-management',           
          name: 'AdScreeningSubmissionsManagement',           
          component: () => import('@/views/AdScreeningSubmissionsManagement.vue'),           
          meta: { title: 'AD认知筛查提交管理', icon: 'el-icon-document', showInTab: true }        },
        {           
          path: 'care-institutions-management',           
          name: 'CareInstitutionsManagement',           
          component: () => import('@/views/CareInstitutionsManagement.vue'),           
          meta: { title: '照护机构管理', icon: 'el-icon-building', showInTab: true }        }      
  ]    },
  ]
})

// 动态添加路由的方法
export const addDynamicRoutes = async () => {
  // 如果已经加载过，则不再重复加载
  if (dynamicRoutesLoaded) {
    console.log('动态路由已加载，跳过重复加载')
    return
  }
  
  try {
    console.log('开始加载动态路由...')
    const menus = await menuAPI.getUserMenus()
    console.log('获取到用户菜单:', menus)
    
    if (menus && menus.length > 0) {
      const dynamicRoutes = convertMenusToRoutes(menus)
      console.log('转换后的动态路由:', dynamicRoutes)
      
      // 找到Layout路由并添加动态路由
        const layoutRoute = router.options.routes.find(route => route.path === '/')
        if (layoutRoute && layoutRoute.children) {
          // 保存当前动态路由状态
          currentDynamicRoutes = dynamicRoutes
          
          // 添加新的动态路由
          layoutRoute.children.push(...dynamicRoutes)
          
          // 记录已注册的路由路径
          dynamicRoutes.forEach(route => {
            registeredRoutes.add(`/${route.path}`)
          })
          
          // 重新设置路由
          router.matcher = new Router({
            mode: 'history',
            routes: router.options.routes
          }).matcher
          
          // 设置路由已加载标志
          dynamicRoutesLoaded = true
          
          console.log('动态路由添加成功，当前路由数量:', layoutRoute.children.length)
          console.log('已注册的路由路径:', Array.from(registeredRoutes))
      }
    } else {
      console.warn('未获取到用户菜单或菜单为空')
    }
  } catch (error) {
    console.error('加载动态路由失败:', error)
    // 抛出错误以便调用方可以处理
    throw error
  }
}

// 刷新路由的方法（用于菜单增删改后调用）
export const refreshRoutes = async () => {
  console.log('刷新路由配置...')
  // 重置已加载标志，强制重新加载
  dynamicRoutesLoaded = false
  await addDynamicRoutes()
  console.log('路由刷新完成')
}

// 获取当前动态路由配置
export const getCurrentDynamicRoutes = () => {
  return [...currentDynamicRoutes]
}

// 将菜单转换为路由配置
const convertMenusToRoutes = (menus) => {
  const routes = []
  
  const processMenu = (menu) => {
    if (menu.status && menu.path && menu.component) {
      // 处理组件路径，确保正确的导入格式
      let componentPath = menu.component
      
      // 如果组件路径以 ../ 开头，去掉 ../ 前缀
      if (componentPath.startsWith('../')) {
        componentPath = componentPath.substring(3) // 去掉 "../"
      }
      
      // 如果组件路径以 ./ 开头，去掉 ./ 前缀
      if (componentPath.startsWith('./')) {
        componentPath = componentPath.substring(2) // 去掉 "./"
      }
      
      // 确保组件路径以 .vue 结尾
      if (!componentPath.endsWith('.vue')) {
        componentPath += '.vue'
      }
      
      // 使用真正的动态导入
      const route = {
        path: menu.path.startsWith('/') ? menu.path.substring(1) : menu.path,
        name: menu.routeName || menu.name,
        component: () => import(/* webpackChunkName: "views-[request]" */ `@/views/${componentPath}`).catch(error => {
          console.error(`动态加载组件失败: ${componentPath}`, error)
          // 返回一个空的组件作为降级方案
          return {
            template: '<div>页面加载失败，请检查组件路径是否正确</div>',
            mounted() {
              this.$message.error(`页面加载失败: ${componentPath}`)
            }
          }
        }),
        meta: {
          title: menu.name,
          icon: menu.icon || 'el-icon-menu',
          showInTab: menu.showInTab !== undefined ? menu.showInTab : true
        }
      }
      routes.push(route)
    }
    
    // 递归处理子菜单
    if (menu.children && menu.children.length > 0) {
      menu.children.forEach(child => processMenu(child))
    }
  }
  
  menus.forEach(menu => processMenu(menu))
  return routes
}

// 检查路由是否存在
const routeExists = (path) => {
  // 快速检查是否在已注册路由中
  if (registeredRoutes.has(path)) {
    return true
  }
  
  // 详细检查路由表
  try {
    const found = router.match(path)
    return found && found.matched.length > 0
  } catch (error) {
    return false
  }
}

// 全局前置守卫，确保路由加载完成
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  const isLoginRoute = to.path === '/login'

  // 关键：刷新动态路由页面时（如 /ScienceArticleManagement），该路由尚未注册，
  // to.matched 为空导致 to.meta 取不到 requiresAuth，会被误判为“无需认证”直接放行，
  // 最终匹配不到任何组件而白屏。这里按路径兜底推断是否需要登录。
  const requiresAuth = to.meta.requiresAuth !== undefined ? to.meta.requiresAuth : !isLoginRoute

  console.log(`导航到: ${to.path}, 需要认证: ${requiresAuth}, 已认证: ${!!isAuthenticated}`)

  // 如果需要认证且未登录，跳转到登录页
  if (requiresAuth && !isAuthenticated) {
    console.log('未登录，重定向到登录页')
    next('/login')
    return
  }

  // 如果已登录且访问登录页，跳转到首页
  if (isLoginRoute && isAuthenticated) {
    console.log('已登录，重定向到首页')
    next('/')
    return
  }

  // 如果是根路径，重定向到仪表盘
  if (to.path === '/') {
    console.log('访问根路径，重定向到仪表盘')
    next('/dashboard')
    return
  }

  // 如果需要认证且动态路由尚未加载，先加载动态路由
  if (requiresAuth && !dynamicRoutesLoaded) {
    try {
      console.log('动态路由未加载，开始加载...')
      await addDynamicRoutes()

      // 检查目标路由是否存在
      if (routeExists(to.path)) {
        console.log(`路由 ${to.path} 存在，重新导航`)
        // 重新导航到目标路由以确保路由配置已更新
        next({ path: to.path, query: to.query, hash: to.hash, replace: true })
      } else {
        console.warn(`路由 ${to.path} 不存在，重定向到仪表盘`)
        next('/dashboard')
      }
    } catch (error) {
      console.error('路由加载失败:', error)
      next('/dashboard')
    }
    return
  }

  // 检查路由是否存在
  if (requiresAuth && !routeExists(to.path)) {
    console.warn(`路由 ${to.path} 不存在，重定向到仪表盘`)
    next('/dashboard')
    return
  }

  next()
})

// 导出注册的路由路径集合，用于外部检查
export const getRegisteredRoutes = () => {
  return new Set(registeredRoutes)
}

export default router
